// src/components/Hero.jsx
import { motion } from "framer-motion";
import FlipWords from "./FlipWords";

const words = ["Zentra Group", "Zentra Sistemas", "Zentra POS", "Zentra GPS"];

export default function Hero() {
  const scrollToSection = (id) => {
    if (typeof window === "undefined") return;

    const el = document.getElementById(id);
    if (!el) return;

    const navOffset = 80;
    const y = el.getBoundingClientRect().top + window.scrollY - navOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <section className="relative overflow-hidden bg-white">
      {/* Fondo con colores Zentra */}
      <div className="absolute inset-0 bg-brand-radials" />
      <div className="absolute left-1/2 top-10 h-72 w-72 -translate-x-1/2 rounded-full bg-[#5d83f3]/10 blur-3xl" />
      <div className="absolute -left-32 top-32 h-80 w-80 rounded-full bg-[#204b97]/10 blur-3xl" />
      <div className="absolute -right-32 bottom-0 h-80 w-80 rounded-full bg-[#0f172a]/10 blur-3xl" />

      <div className="relative z-10 mx-auto flex min-h-[calc(100vh-80px)] max-w-6xl flex-col items-center justify-center px-4 py-12 text-center sm:px-6 lg:px-8">
        {/* Badge */}
        <motion.button
          type="button"
          onClick={() => scrollToSection("servicios")}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="inline-flex items-center gap-2 rounded-full border border-[rgba(2,6,23,.10)] bg-white/90 px-4 py-2 text-[13px] font-medium text-ink-muted shadow-sm backdrop-blur transition hover:-translate-y-0.5 hover:border-[#204b97]/20 hover:text-[#204b97]"
        >
          <span className="grid h-5 w-5 place-items-center rounded-full bg-[linear-gradient(90deg,#0f172a_0%,#204b97_55%,#5d83f3_100%)] text-[11px] text-white">
            ✨
          </span>
          Tecnología que impulsa tu operación
          <span className="text-[#5d83f3]">→</span>
        </motion.button>

        {/* Título */}
        <motion.h1
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.05 }}
          className="mt-6 heading-display max-w-5xl text-[42px] font-extrabold leading-[1.04] tracking-tight text-ink sm:text-[54px] md:text-[66px] lg:text-[78px] lg:leading-[0.98]"
        >
          Digitalizamos tu negocio con

          <span className="mt-1 block bg-[linear-gradient(90deg,#0f172a_0%,#204b97_52%,#5d83f3_100%)] bg-clip-text text-transparent">
            <FlipWords words={words} />
          </span>
        </motion.h1>

        {/* Texto */}
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mx-auto mt-5 max-w-2xl text-[16px] leading-7 text-ink-muted md:text-[18px]"
        >
          Creamos sistemas web, plataformas personalizadas, soluciones POS y GPS
          para ordenar procesos, controlar operaciones y vender mejor.
        </motion.p>

        {/* Botones */}
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row"
        >
          <button
            type="button"
            onClick={() => scrollToSection("servicios")}
            className="btn-brand inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-[15px] font-semibold shadow-[0_14px_32px_rgba(32,75,151,0.24)] transition hover:-translate-y-0.5 hover:shadow-[0_18px_40px_rgba(32,75,151,0.30)]"
          >
            Ver soluciones
            <span>→</span>
          </button>

          <button
            type="button"
            onClick={() => scrollToSection("nosotros")}
            className="inline-flex items-center justify-center rounded-full border border-[rgba(2,6,23,.10)] bg-white px-6 py-3 text-[15px] font-semibold text-ink shadow-sm transition hover:-translate-y-0.5 hover:border-[#204b97]/25 hover:text-[#204b97]"
          >
            Conócenos
          </button>
        </motion.div>

        {/* Servicios compactos */}
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-10 grid w-full max-w-3xl grid-cols-1 gap-3 sm:grid-cols-3"
        >
          <ServiceMini title="Sistemas" text="Webs, paneles y plataformas" />
          <ServiceMini title="POS" text="Boletas, ventas e inventario" />
          <ServiceMini title="GPS" text="Flotas y monitoreo en vivo" />
        </motion.div>
      </div>
    </section>
  );
}

function ServiceMini({ title, text }) {
  return (
    <div className="rounded-2xl border border-[rgba(2,6,23,.08)] bg-white/80 px-5 py-4 text-left shadow-sm backdrop-blur transition hover:-translate-y-1 hover:border-[#204b97]/20 hover:shadow-md">
      <p className="text-sm font-bold text-[#204b97]">{title}</p>
      <p className="mt-1 text-sm leading-5 text-ink-muted">{text}</p>
    </div>
  );
}